(() => {
  if (customElements.get('product-card-carousel')) {
    return;
  }

  class ProductCardCarousel extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.product-card__slides');
      this.dots = Array.from(this.querySelectorAll('.product-card__carousel-dot'));

      if (!this.scroller) {
        return;
      }

      this.querySelectorAll('.product-card__carousel-arrow').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.scrollByDirection(button.dataset.direction === 'next' ? 1 : -1);
        });
      });

      this.scroller.addEventListener(
        'scroll',
        () => {
          window.clearTimeout(this._scrollTimer);
          this._scrollTimer = window.setTimeout(() => this.syncDots(), 60);
        },
        { passive: true }
      );
    }

    scrollByDirection(direction) {
      const width = this.scroller.clientWidth;
      const maxScroll = this.scroller.scrollWidth - width;
      let target = Math.round(this.scroller.scrollLeft / width) * width + direction * width;

      if (target < -1) {
        target = maxScroll;
      } else if (target > maxScroll + 1) {
        target = 0;
      }

      this.scroller.scrollTo({ left: target, behavior: 'smooth' });
    }

    syncDots() {
      if (!this.dots.length || this.scroller.clientWidth === 0) {
        return;
      }

      const index = Math.round(this.scroller.scrollLeft / this.scroller.clientWidth);

      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }
  }

  customElements.define('product-card-carousel', ProductCardCarousel);
})();
